﻿import bulmaCollapsible from '@creativebulma/bulma-collapsible';

document.addEventListener('DOMContentLoaded', () => {
    let $tipInstance = null;
    const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible:not(.is-collapsible--vue)');

    bulmaCollapsibleInstances.forEach(bulmaCollapsibleInstance => {
        bulmaCollapsibleInstance.on('after:expand', function () {
            bulmaCollapsibleInstance._originalHeight = bulmaCollapsibleInstance.element.scrollHeight + 'px';
        }); 
        if (bulmaCollapsibleInstance.element.id === 'mainSearch') {
            const $form = bulmaCollapsibleInstance.element;
            const $input = $form.querySelector('input');
            const $button = $form.querySelector('button');
            let buttonClicked = false;
            $button.addEventListener('click', (event) => {
                buttonClicked = true;
            });
            $input.addEventListener('blur', () => {
                setTimeout(() => {
                    if (!buttonClicked) {
                        bulmaCollapsibleInstance.collapse();
                    }
                }, 300);
            });
            bulmaCollapsibleInstance.on('after:expand', () => {
                $input.focus();
            });
            $form.addEventListener('submit', function (e) {
                e.preventDefault();
                if ($input.value.trim() !== '') {
                    $form.submit();
                } else {
                    $input.focus();
                }
            });
        }

        if (bulmaCollapsibleInstance.element.id === 'order-banner-collapse') {
            bulmaCollapsibleInstance.on('after:collapse', (e) => {
                if ($tipInstance !== null) {
                    $tipInstance.close();
                }
            });
        }

        if (bulmaCollapsibleInstance.element.id === 'pricelist') {
            $tipInstance = bulmaCollapsibleInstance;
            const $tip = bulmaCollapsibleInstance.element;
            const $trigger = bulmaCollapsibleInstance._triggers[0];
            setTooltipPos($tip, $trigger);
            window.addEventListener('resize', () => {
                setTooltipPos($tip, $trigger);
            });
            window.addEventListener("scroll", () => {
                setTooltipPos($tip, $trigger);
            });
            document.addEventListener('click', event => {
                if (!$tip.contains(event.target) && !$trigger.contains(event.target)) {
                    $tipInstance.collapse();
                }
            });
        }

        if (bulmaCollapsibleInstance.element.id === 'collapse-Functioneel' || bulmaCollapsibleInstance.element.id === 'collapse-Marketing') {
            bulmaCollapsibleInstance.on('after:expand', function () {
                bulmaCollapsibleInstance._originalHeight = bulmaCollapsibleInstance.element.scrollHeight + 20 + 'px';
            }); 
        }
    });
});

const setTooltipPos = ($tip, $trigger) => {
    let tipRect = $tip.getBoundingClientRect();
    let triggerRect = $trigger.getBoundingClientRect();
    let top = triggerRect.top + triggerRect.height + window.scrollY;
    let left = triggerRect.left + triggerRect.width / 2 - tipRect.width / 2 < 0 ? 24 : triggerRect.left + triggerRect.width / 2 - tipRect.width / 2;
    $tip.style.top = top + 20 + 'px';
    $tip.style.left = left + 'px';
}